export const CONSENT_SERVICES = {
  youtube: { category: "media", label: "YouTube" },
  vimeo: { category: "media", label: "Vimeo" },
  arnes: { category: "media", label: "Arnes Video" },
  googlemaps: { category: "maps", label: "Google Maps" },
};
